import { WebappSdkApiResponse } from '@deputyapp/webapp-sdk/src/types/webapp-sdk-api';
// TODO: upcoming change for NOMONO TS config
// import type { WebappSdkApiResponse } from '@deputyapp/webapp-sdk/src/types/webapp-sdk-api';
import { AxiosError } from 'axios';
// TODO: upcoming change for NOMONO TS config
// import type { AxiosError } from 'axios';
import { useApi } from '@deputyapp/webapp-sdk';

export type LeaveModuleV2Config = {
  config?: {
    leaveManagementEnabled: boolean;
    perEmployeeEntitlementsEnabled: boolean;
    perEmployeeStandardDayEnabled: boolean;
  };
  message?: string;
};

export default async function getLeaveModuleV2Config(): Promise<
  Omit<WebappSdkApiResponse<LeaveModuleV2Config>, 'headers' | 'meta'>
> {
  const { v2 } = useApi();
  const { get } = v2;

  try {
    const { data } = await get<LeaveModuleV2Config>(
      '/api/management/v2/leave-config'
    );

    return {
      success: true,
      data: data,
      message: data.message || '',
    };
  } catch (e) {
    const error = e as AxiosError;
    console.error(error);

    return {
      success: false,
      data: {},
      message: error.message,
    };
  }
}
